import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { IProfile } from "@/types/entities/IProfile";
import router from "@/router";
import routesName from "@/utils/constants/routesName";
import { useCourseStore } from "@/stores/course";
import { UserRoleEnum } from "@/utils/enum/UserRoleEnum";

export const useUserStore = defineStore(
  "user",
  () => {
    const courseStore = useCourseStore();

    const accessToken = ref<string>("");
    const refreshToken = ref<string>("");
    const userData = ref<IProfile | null>(null);

    const setTokens = (payload: {
      accessToken: string;
      refreshToken: string;
    }): void => {
      accessToken.value = payload.accessToken;
      refreshToken.value = payload.refreshToken;
    };

    const setUserProfile = (profile: IProfile): void => {
      userData.value = profile;
    };

    const isAdmin = computed<boolean>(
      () => userData.value?.role === UserRoleEnum.admin
    );
    const isManager = computed<boolean>(
      () => userData.value?.role === UserRoleEnum.manager
    );

    const clear = (): void => {
      accessToken.value = "";
      refreshToken.value = "";
      userData.value = null;
      courseStore.clearAll();
      router.push({ name: routesName.login });
    };

    return {
      accessToken,
      refreshToken,
      userData,
      setTokens,
      setUserProfile,
      isAdmin,
      isManager,
      clear,
    };
  },
  {
    persist: true,
  }
);
